<template>
  <div name="demo-upload-single">
    <hrms-dropzone v-model="fileName"
                  :fileNameQuery="'XXXXXXXX.jpg'"
                  v-validate="'required'"
                  data-vv-value-path="resultFileName"
                  :data-vv-as="'dropzone'"
                  :data-vv-name="'dropzone'"
                  :name="'dropzone'"
                  :has-error="errors.has('dropzone')" />
    <div v-show="errors.has('dropzone')" class="text-error">{{ errors.first('dropzone') }}</div>
    {{fileName}}
  </div>
</template>

<script>
export default {
  name: 'demo-upload-single',
  data () {
    return {
      fileDir: '\\\\192.168.2.18\\temp\\',
      fileName: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoUploadSingle.vue?45e8818c